import Select from 'react-select';
import styled, { css } from 'styled-components/macro';

export const Dropdown = styled(Select)<{ filterDropdown?: boolean; error?: string }>`
  ${({ filterDropdown }) =>
    filterDropdown &&
    css`
      @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 100%;
      }
    `}

  .true__control {
    height: 2.5rem;
    padding: ${({ theme }) => '0 0 0 ' + theme.spacing.zero_3};
    border-color: ${({ theme, error }) =>
      error === 'hasError' ? theme.colors.negative_dark : theme.colors.black_20};
    box-shadow: none;

    background-color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_5 : theme.colors.white};

    &--is-focused {
      border-color: ${({ theme }) => theme.colors.black};
    }
    :hover {
      border-color: ${({ theme }) => theme.colors.black_10};
    }
    ${({ filterDropdown }) =>
      filterDropdown &&
      css`
        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
          width: 100%;
        }
      `}
  }

  .true__value-container {
    flex-wrap: nowrap;
    padding: 0;
  }

  .true__single-value {
    position: static;
    top: 0;

    max-width: 100%;
    margin: 0;

    color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_40 : theme.colors.black_100};
    text-overflow: initial;

    transform: translateY(0);
  }

  .true__control--menu-is-open {
    border: 1px solid;
    border-color: ${({ theme, error }) =>
      error === 'hasError' ? theme.colors.negative_dark : theme.colors.black} !important;

    box-shadow: none;
  }

  .true__indicator-separator {
    display: none;
  }

  .true__menu {
    z-index: 100;

    color: ${({ theme }) => theme.colors.black_100};
  }

  .true__placeholder {
    position: static;
    top: 0;

    color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_40 : theme.colors.black_100};

    transform: translateY(0);
  }
`;
